import {Box, Text, VStack} from "@hosttools/frontend";
import type React from "react";
import {memo} from "react";

const AirbnbCredential: React.FC = () => {
    return (
        <>
            <Box className="mb-4">
                <Text isParagraph variant="xs">
                    After connecting your Airbnb account to Host Tools, some of the Airbnb account
                    settings will change.&nbsp;
                    <Text isParagraph color="blue.600" variant="xs">
                        <a
                            href="https://help.hosttools.com/en/articles/6289414-what-will-change-on-my-airbnb-account-when-i-connect-it-to-host-tools"
                            rel="noreferrer"
                            target="_blank"
                        >
                            Read more.
                        </a>
                    </Text>
                </Text>
            </Box>
            <VStack className="ml-2" space="md">
                <Text variant="sm">• Fee settings may change to host-only.</Text>
                <Text variant="sm">• Instant book will be enabled on all listings.</Text>
                <Text variant="sm">• All imported iCals will be removed from Airbnb.</Text>
            </VStack>
        </>
    );
};

export default memo(AirbnbCredential);
